import { PostResult, PostSection, ReleasePost, StandardPost } from "Post/PostTypes";
import { TaggedImage } from "constructs/TaggedImage";


export function transformPostResult(result: PostResult): StandardPost | ReleasePost {
  let body: Array<PostSection>;
  let image: TaggedImage | undefined;

  body = JSON.parse(result.body);
 
  
  if (result.image) {
    const imageObf = result.image.obfuscations ? JSON.parse(result.image.obfuscations) : [];
    const imageStyles = result.image.styles ? JSON.parse(result.image.styles) : {};
    image = {
      ...result.image,
      obfuscations: imageObf,
      styles: imageStyles,
    } 
  }

  const post: StandardPost = { ...result, image, body, kind: "standard" };

  return post;

}